import React, { Component } from 'react'
import Loading from '../Loading/Loading';

class ForceRerenderWrapper extends Component {

    state = {
        rendering: false
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if(newProps.refreshParam !== this.props.refreshParam) {
            this.setState({ rendering: false })
        } else{
            if(this.props.match.params[this.props.refreshParam] !== newProps.match.params[this.props.refreshParam]) {
                this.setState({ rendering: false });
            }
        }
    }

    render () {
        if(this.state.rendering === false) {
            setTimeout(() => this.setState({ rendering: true }), 10);
            return <Loading />;
        }
        return this.props.children;
    }
}

export default ForceRerenderWrapper